import React from 'react';
import { Box, Link, Typography, useTheme } from '@mui/material';

export default function IapNotice() {
    const theme = useTheme();

    return (
        <Box display="flex" justifyContent="flex-end" width="100%" marginTop={2}>
            <Typography variant="caption">
                This is an In-app Purchase and must be managed in your{' '}
                <Link
                    href="https://apps.apple.com/account/subscriptions"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                        color: theme.palette.primary.main,
                        textDecoration: 'none',
                        fontWeight: 500,
                        '&:hover': { textDecoration: 'underline' },
                    }}
                >
                    Apple subscriptions
                </Link>
                .
            </Typography>
        </Box>
    );
}
